/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 08:58:58
 * @LastEditTime: 2020-12-28 18:12:11
 */
import i18n from "@/common/lang";
export const Columns = [
  { LabelName: i18n.t('lang.devicelist.SerialNumber'), row: 80, align: 'center', key: 0, ColumnsKey: 'Index', slot: true },
  { LabelName: i18n.t('lang.alarmContact.name'), key: 1, ColumnsKey: 'name', seek: 'name', sort: 'custom' },
  // { LabelName: i18n.t('lang.alarmContact.phone'), key: 2, ColumnsKey: 'phone', seek: 'phone', sort: 'custom' },
  { LabelName: i18n.t('lang.alarmContact.email'), key: 3, ColumnsKey: 'email', seek: 'email', sort: 'custom' },
  // { LabelName: i18n.t('lang.alarmContact.wechat'), key: 6, ColumnsKey: 'wechat', seek: 'wechat', sort: 'custom' },
  { LabelName: i18n.t('lang.alarmContact.Remark'), key: 7, ColumnsKey: 'remark' },
]

export const ColuumnsButton = [
  // { key: 0, type: 'primary', icon: 'icon-chaxun', Fun: 'showDetail', Authority: 53 },
  { key: 1, type: 'primary', icon: 'el-icon-edit', Fun: 'editcontactList', Authority: 261 },
  { key: 2, type: 'danger', icon: 'el-icon-delete', Fun: 'deleteContact', Delete: true, Authority: 262 },
]
